export default "__VITE_PUBLIC_ASSET__76c03e80__"